import { QueryProbeDomainArgs } from '@tribeplatform/gql-client/types'

import { KeyConstructor } from './keyConstructor.js'

const PROBE_DOMAIN_KEY = 'probe-domain'

export const getProbeDomainKey = KeyConstructor<QueryProbeDomainArgs, never>(
  PROBE_DOMAIN_KEY,
)
